import React from 'react';
import { FeatherLock, FeatherX } from '@subframe/core';
import { Alert } from '../ui/components/Alert';
import { Button } from '../ui/components/Button';
import { IconButton } from '../ui/components/IconButton';
import { useSignInModalStore } from '../store/signInModalStore';

interface SignInBannerProps {
  onDismiss: () => void;
}

/**
 * A CTA banner shown to logged-out users encouraging them to sign in.
 * Displays on all pages and can be dismissed for the current session.
 * Sign In opens the app-wide wallet picker (Xaman + Joey).
 */
export const SignInBanner: React.FC<SignInBannerProps> = ({ onDismiss }) => {
  const openSignIn = useSignInModalStore((s) => s.open);

  return (
    <div className="w-full max-w-[1400px] px-6 pt-6 mobile:px-4 mobile:pt-4">
      <Alert
        variant="brand"
        icon={<FeatherLock />}
        title="Sign in to unlock premium features"
        description="Access PnL tracking, price alerts, and personalized collection alerts"
        actions={
          <div className="flex items-center gap-2">
            <Button variant="brand-primary" size="small" onClick={openSignIn}>
              Sign In
            </Button>
            <IconButton icon={<FeatherX />} size="small" onClick={onDismiss} />
          </div>
        }
      />
    </div>
  );
};
